import { defineMessages } from "@/i18n";
import en from "./en";

export const settingsCliLoginsMessages = defineMessages(
  "settings-cli-logins",
  en,
);
